(function () {
    window.boneCardService = {
      get() {
        return axios.get(`/api/bonecard/get.php`);
      },
      save(data) {
        return axios.post('/api/bonecard/save.php', data);
      },
      getAscension() {
        return axios.get('/api/ascension/get.php');
      },
    };
  })();
  